// Detect diagram type from code
export function detectDiagramType(code) {
  const trimmed = code.trim().toLowerCase();
  
  if (trimmed.startsWith('graph ') || trimmed.startsWith('flowchart ')) {
    return 'flowchart';
  } else if (trimmed.startsWith('sequencediagram')) {
    return 'sequence';
  } else if (trimmed.startsWith('classdiagram')) {
    return 'class';
  } else if (trimmed.startsWith('statediagram')) {
    return 'state';
  } else if (trimmed.startsWith('erdiagram')) {
    return 'er';
  } else if (trimmed.startsWith('gantt')) {
    return 'gantt';
  } else if (trimmed.startsWith('pie ')) {
    return 'pie';
  } else if (trimmed.startsWith('journey')) {
    return 'journey';
  } else if (trimmed.startsWith('gitgraph')) {
    return 'gitgraph';
  } else {
    return 'flowchart'; // Default
  }
}

// Search diagrams
export function searchDiagrams(diagrams, query) {
  if (!query || !query.trim()) {
    return diagrams;
  }
  
  const searchTerm = query.toLowerCase().trim();
  
  return diagrams.filter(diagram => {
    return (
      diagram.name.toLowerCase().includes(searchTerm) ||
      diagram.type.toLowerCase().includes(searchTerm) ||
      diagram.description.toLowerCase().includes(searchTerm) ||
      (diagram.tags && diagram.tags.some(tag => 
        tag.toLowerCase().includes(searchTerm)
      )) ||
      diagram.code.toLowerCase().includes(searchTerm)
    );
  });
}

// Filter diagrams by type
export function filterDiagramsByType(diagrams, type) {
  if (!type || type === 'all') {
    return diagrams;
  }
  return diagrams.filter(diagram => diagram.type === type);
}

// Get unique diagram types from a list of diagrams
export function getUniqueTypes(diagrams) {
  const types = new Set();
  diagrams.forEach(diagram => {
    if (diagram.type) {
      types.add(diagram.type);
    }
  });
  return Array.from(types).sort();
}
